import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '@core/config/app.config.service';
import { Api } from '@core/models/Api.model';
import { InactivityService } from '@shared/services/apl-afiliacion/login/inactivity.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(private readonly inactivityService: InactivityService,
        private readonly _configService: ConfigService, private readonly router: Router) {
        Api.initialize(this._configService);
        this.corregirUrlMalaDeAnubis();
    }

    ngOnInit() {
        this.inactivityService.startMonitoring();
    }

     private corregirUrlMalaDeAnubis() {
        const urlActual = window.location.href;

        if (urlActual.includes('?idValidacion=') && urlActual.includes('#/home/')) {
            
            try {
                // Separamos usando la sección del Hash '#/' como pivote
                const [parteIzquierda, parteDerecha] = urlActual.split('#/');

                // De la parte izquierda, aislamos los query params después del '?'
                const [, queryParamsString] = parteIzquierda.split('?');

                // Reconstruimos la URL en el orden correcto exigido por Angular: /#/ruta?parametros
                const nuevaUrlCorregida = `/#/${parteDerecha}?${queryParamsString}`;

                // Reemplazamos la barra de direcciones del navegador sin recargar la pestaña
                window.history.replaceState({}, '', nuevaUrlCorregida);
                
                // Forzamos al enrutador de Angular a procesar la ruta corregida
                this.router.navigateByUrl(`/${parteDerecha}?${queryParamsString}`);
            } catch (e) {
                console.error('Error al reparar la URL de retorno de Anubis:', e);
            }
        }
}
}
